import theme_icons from '../../icons.js';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { InspectorControls, ColorPalette, InnerBlocks } = wp.blockEditor;
const { PanelBody, SelectControl, TextControl } = wp.components;

const greenheartframe = {
    title: 'Greenheart Section',
    icon: theme_icons.greenheart,
    category: 'greenheart',
    supports: {
        align: ['wide', 'full']
    },
    //attributes
    attributes: {
        title: {
            type: 'string',
            default: ''
        },
        frameTexture: {
            type: 'string',
            default: ''
        },
        backgroundColor: {
            type: 'string',
            default: ''
        },
        frameColor: {
            type: 'string',
            default: ''
        },
        backgroundTexture: {
            type: 'string',
            default: ''
        }
    },

    edit({ attributes, setAttributes }) {
        const { title, frameTexture, frameColor, backgroundColor, backgroundTexture } = attributes;
        return ([
            <InspectorControls>
                <PanelBody title="Section Settings">
                    <p><strong>Title (for direct links - don't use spaces)</strong></p>
                    <p>Reference like '/page-link/#{title}'</p>
                    <TextControl
                        value={title}
                        onChange={(newText) => setAttributes({ title: newText.replace(/\s+/g, '-') })}
                        placeholder="Leave Blank for no Section Link"
                    />

                    <p><strong>Edge Color</strong></p>
                    <ColorPalette
                        label="Choose Color"
                        value={frameColor}
                        onChange={(color) => setAttributes({ frameColor: color })}
                    />
                    <p><strong>Edge Texture</strong></p>
                    <SelectControl
                        label={"Texture"}
                        value={frameTexture}
                        options={[
                            { label: "None", value: "" },
                            { label: "Torn Paper", value: "torn-paper" },
                            { label: "Gradient", value: "gradient" },
                            { label: "Sand", value: "sand" }
                        ]}
                        onChange={(val) => setAttributes({ frameTexture: val })}
                    />
                    <p><strong>Background Color</strong></p>
                    <ColorPalette
                        label="Choose Color"
                        value={backgroundColor}
                        onChange={(color) => setAttributes({ backgroundColor: color })}
                    />
                    <p><strong>Background Texture</strong></p>
                    <SelectControl
                        label={"Texture"}
                        value={backgroundTexture}
                        options={[
                            { label: "None", value: "" },
                            { label: "Topography Map", value: "topography" },
                            { label: "World Map", value: "worldmap" },
                            { label: "Sand", value: "sand" }
                        ]}
                        onChange={(val) => setAttributes({ backgroundTexture: val })}
                    />
                </PanelBody>
            </InspectorControls>,
            <div className={backgroundTexture ? "rbt-greenheartframe " + backgroundTexture : "rbt-greenheartframe"} style={{ backgroundColor: backgroundColor }}>
                {frameTexture === 'torn-paper' && <span className="torn-paper-top" style={{ color: frameColor }}></span>}
                {frameTexture === 'gradient' && <span className="gradient-top" style={{ color: frameColor }}></span>}
                {frameTexture === 'sand' && <span className="sand-top" style={{ color: frameColor }}></span>}

                <InnerBlocks />

                {frameTexture === 'torn-paper' && <span className="torn-paper-bottom" style={{ color: frameColor }}></span>}
                {frameTexture === 'sand' && <span className="sand-bottom" style={{ color: frameColor }}></span>}
                {frameTexture === 'gradient' && <span className="gradient-bottom" style={{ color: frameColor }}></span>}
            </div>
        ]);
    },
    save({ attributes }) {
        const { title, frameTexture, frameColor, backgroundColor, backgroundTexture } = attributes;

        return (
            <div id={title ? title : undefined} className={backgroundTexture ? "rbt-greenheartframe " + backgroundTexture : "rbt-greenheartframe"} style={{ backgroundColor: backgroundColor }}>
                {frameTexture === 'torn-paper' && <span className="torn-paper-top" style={{ color: frameColor }}></span>}
                {frameTexture === 'gradient' && <span className="gradient-top" style={{ color: frameColor }}></span>}
                {frameTexture === 'sand' && <span className="sand-top" style={{ color: frameColor }}></span>}

                <InnerBlocks.Content />

                {frameTexture === 'torn-paper' && <span className="torn-paper-bottom" style={{ color: frameColor }}></span>}
                {frameTexture === 'sand' && <span className="sand-bottom" style={{ color: frameColor }}></span>}
                {frameTexture === 'gradient' && <span className="gradient-bottom" style={{ color: frameColor }}></span>}
            </div>
        );
    }
};
registerBlockType('rbt/greenheartframe', greenheartframe);
export default greenheartframe;
